import { Box } from '@mui/material';

const Toolbar = ({ children }) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            my={1.5}
            gap={2}
        >
            {children}
        </Box>
    );
};

export default Toolbar;
